module.exports = __webpack_public_path__ + "img/room19.41570305.gif";